import { assertRealBackendForProduction } from './mockMode';

/**
 * EPN-98 — browser-start-up half of the "no mocks in Production" rule (the build-time half lives in
 * `vite.config.ts`). Imported FIRST by `main.tsx`, so when a production bundle somehow carries
 * mock mode (e.g. an artifact built before this guard existed, or by a toolchain that bypasses the
 * Vite plugin) the module graph aborts here, BEFORE any Mock gateway is constructed or any screen
 * renders, and the operator sees an explicit message instead of a plausible-looking fake payroll UI.
 *
 * `import.meta.env.PROD` is true for every `vite build` output and false for the dev server and for
 * Vitest, so development and automated tests keep their convenient mock default.
 */
try {
  assertRealBackendForProduction(
    import.meta.env.PROD,
    import.meta.env.VITE_USE_MOCKS,
    import.meta.env.VITE_USE_BUSINESS_PROFILE_MOCKS,
  );
} catch (error) {
  const message = error instanceof Error ? error.message : String(error);
  const root = document.getElementById('root');
  if (root) {
    root.textContent = `EPN cannot start: ${message}`;
  }
  throw error;
}
